//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodSizeEdit', {
//        templateUrl: 'views/components/views/prodSizeEdit/prodSizeEdit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'prodSizeEditService', function ($stateParams, stateService, utilityService, prodSizeEditService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodSizeKeyNo = $stateParams.prodsize_keyno;
            
//            vm.model = {
//                bgColli: {
//                    selected: 'COLLIINPUT',
//                    buttons: [
//                        { id: 'COLLIINPUT', label: 'bg_colli_colliinput', color: 'primary', onClick: () => vm.model.bgColli.selected = 'COLLIINPUT' },
//                        { id: 'COLLIEXAMPLE', label: 'bg_colli_colliexample', color: 'primary', onClick: () => vm.model.bgColli.selected = 'COLLIEXAMPLE' }
//                    ]
//                },
//                edit: {},
//                itemsListCollis: [],
//                itemsListNobbs: [],
//                itemsListColliExamples: [],
//                lockedSave: false,
//                creating: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await prodSizeEditService.getEdit({ prodsize_keyno: prodSizeKeyNo }))[0];
//            }

//            async function loadCollis() {
//                if (utilityService.validateParmsValue(vm.model.edit.prodsize_keyno) !== true) return;

//                return vm.model.itemsListCollis = await prodSizeEditService.listCollis({ prodsize_keyno: vm.model.edit.prodsize_keyno });
//            }

//            async function loadNobbs() {
//                if (utilityService.validateParmsValue(vm.model.edit.prodsize_keyno) !== true) return;

//                return vm.model.itemsListNobbs = await prodSizeEditService.listNobbs({ prodsize_keyno: vm.model.edit.prodsize_keyno });
//            }

//            async function loadColliExamples() {
//                if (utilityService.validateParmsValue(vm.model.edit.colliexampleqty, true) !== true) return;

//                vm.model.itemsListColliExamples = [];

//                return prodSizeEditService.listColliExamples(vm.model.edit).then(function (list) {
//                    vm.model.creating = false;
//                    vm.model.itemsListColliExamples = list;
//                });
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgColli = function (value) {
//                vm.model.bgColli.selected = value;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                prodSizeEditService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON CREATE COLLI EXAMPLE PROCEDURE FUNCTION CALL

//            vm.createColliExample = function () {
//                vm.model.creating = true;
//                loadColliExamples();
//            }

//            // #endregion BUTTON CREATE COLLI EXAMPLE PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'prodsizecolli':
//                        go({
//                            prodsize_keyno: vm.model.edit.prodsize_keyno,
//                            prodsizecolli_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();

//                if (vm.model.edit.nbr_of_prodsizecolli === '0' && vm.model.edit.auto_goto_prodsizecolli === '1') {
//                    stateService.go('prodsizecolli', {
//                        prodsize_keyno: vm.model.edit.prodsize_keyno,
//                        prodsizecolli_keyno: '0'
//                    });
//                }

//                loadCollis();
//                loadNobbs();
//                loadColliExamples();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
